import { makeRequest } from 'utils/requestLogger';

export default (roundtable_id) =>
  makeRequest(
    'get',
    `/api/roundtables/${roundtable_id}/keywords`
  );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/getRoundtableKeywords.js